var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeStudentSizemWeightoutlined = function SvgTypeStudentSizemWeightoutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "m21.237 5.288-9-3a.75.75 0 0 0-.474 0l-9 3A.75.75 0 0 0 2.25 6v7.5a.75.75 0 0 0 1.5 0V7.04L6.9 8.09a6 6 0 0 0 1.935 8.254c-1.688.662-3.146 1.86-4.213 3.496a.75.75 0 1 0 1.256.82c1.413-2.168 3.644-3.41 6.122-3.41s4.71 1.242 6.122 3.41a.75.75 0 0 0 1.256-.82c-1.067-1.637-2.531-2.834-4.213-3.496a6 6 0 0 0 1.936-8.25l4.136-1.378a.75.75 0 0 0 0-1.423zM16.5 11.25a4.5 4.5 0 1 1-8.123-2.667l3.386 1.125a.75.75 0 0 0 .474 0l3.386-1.125a4.5 4.5 0 0 1 .877 2.667M12 8.21 5.372 6 12 3.79 18.628 6z"
  })));
};
export default SvgTypeStudentSizemWeightoutlined;